import { useState } from 'react';
import ReactPaginate from 'react-paginate';

import PropTypes from 'prop-types';
import './Paginate.scss';

const Paginate = ({ pageLimit, total, currentPage, onPageChanged }) => {
  const [pageSize, setPageSize] = useState(pageLimit);
  const pageSizeList = [10, 25, 50, 100];
  const pageCount = Math.ceil(total / pageLimit);
  const limit = Math.ceil(10000 / pageLimit);
  const shouldBlock = pageCount > limit;
  const start = (currentPage + 1) * pageLimit - (pageLimit - 1);
  const end = Math.min(start + pageLimit - 1, total);

  const handlePageClick = async data => {
    onPageChanged({ page: data.selected, limit: pageSize });
  };

  const handlePageSizeChange = async event => {
    const value = parseInt(event.target.value, 10);
    setPageSize(value);
    onPageChanged({ page: 0, limit: value });
  };

  return (
    <div className="paginate">
      <div className="d-flex">
        <div className="p-2 flex-shrink-1 align-self-center">
          <select
            className="form-control"
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            {pageSizeList.map(item => (
              <option value={item} key={`item${item}`}>
                {item}
              </option>
            ))}
          </select>
        </div>
        <div className="p-2 flex-fill align-self-center">per page</div>
        <div className="p-2 align-self-center">
          Showing {start}-{end} of {total}
        </div>
        <div className="p-2 flex-shrink-1 align-self-center">
          <ReactPaginate
            forcePage={currentPage}
            pageCount={shouldBlock ? limit : pageCount}
            onPageChange={handlePageClick}
            previousLabel={<i className="fa fa-angle-left" />}
            nextLabel={<i className="fa fa-angle-right" />}
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            marginPagesDisplayed={5}
            pageRangeDisplayed={5}
            containerClassName="pagination"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            activeClassName="active"
          />
          {shouldBlock && (
            <div>
              <small>
                * Number of pages have been intentionally limited to {limit}
                &nbsp;of&nbsp;
                {pageCount}. Use filters to restrict your criteria before
                paging.
              </small>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Paginate.propTypes = {
  pageLimit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChanged: PropTypes.func.isRequired,
};

export default Paginate;
